module.exports = __webpack_public_path__ + "img/traffic-img.6bb1df04.png";